// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import BootstrapVue from "bootstrap-vue"
import VueFormGenerator from 'vue-form-generator'
import App from './App'
import router from './router/index'
import api from './api/api'
import lodash from './helpers/lodash'
import store from './store'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faTrash, faEdit, faPlus, faMinus, faClipboardCheck, faCheckCircle, faUpload, faTimesCircle, faTimes, faSearchPlus, faSearchMinus, faExclamationTriangle } from '@fortawesome/free-solid-svg-icons'
import { faAdn } from '@fortawesome/free-brands-svg-icons'

library.add(faTrash)
library.add(faEdit)
library.add(faPlus)
library.add(faMinus)
library.add(faClipboardCheck)
library.add(faUpload)
library.add(faTimesCircle)
library.add(faCheckCircle)
library.add(faTimes)
library.add(faSearchPlus)
library.add(faSearchMinus)
library.add(faAdn)
library.add(faExclamationTriangle)


Vue.use(BootstrapVue)
Vue.use(VueFormGenerator)
Vue.use(router)
Vue.use(api)
Vue.use(lodash)

Vue.component('fa', FontAwesomeIcon)
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
	router,
	store,
	render: h => h(App)
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js